<template>
  <table class="table text-left">
    <tbody>
      <tr v-if="rowData.packing_houses">
        <td>
          <span v-for="(item, key) in rowData.packing_houses" :key="key">
            <el-tag type="info" style="height: auto; width: 48%">
              {{ $t('common_words.code') }}: {{ item.code }}<br />
              {{ $t('common_words.name') }}: {{ item.name }}<br />
              {{ $t('common_words.allotment(s)') }}:
              {{ item.lots.map((item) => item.name).join(', ') }}
            </el-tag>
          </span>
        </td>
      </tr>
      <el-tag v-else type="warning" effect="dark" class="mt-2">{{
        $t('common_words.no_assignment')
      }}</el-tag>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'packing-houses-dialog',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
};
</script>
